"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ALL_DATALAKE_AUTH_SCOPES = exports.ALL_LEGACY_AUTH_SCOPES = exports.ALL_BORROWING_BASE_SCOPES = exports.ALL_BORROWING_BASE_PIPELINE_SCOPES = exports.ALL_BANK_ACCOUNT_SCOPES = exports.ALL_CALC_VERIFICATION_SCOPES = exports.ALL_FUNDING_REQUEST_SCOPES = exports.ClassLabel = exports.CreditFacilityStructureType = void 0;
const DataLake_1 = require("./DataLake");
var CreditFacilityStructureType;
(function (CreditFacilityStructureType) {
    CreditFacilityStructureType["FixedProportion"] = "fixedProportion";
    CreditFacilityStructureType["Classed"] = "classed";
})(CreditFacilityStructureType = exports.CreditFacilityStructureType || (exports.CreditFacilityStructureType = {}));
//  ChatGPT replacement option for ClassLabel enum using template literal types:
// type ClassLabelLetters = 'A' | ... | 'F';
//  type ClassLabelNumbers = '' | '1' | '2';
// type ClassLabel = `${ClassLabelLetters}${ClassLabelNumbers}`;
// Class labels can follow a sequence like: A, B, C1, C2, D
var ClassLabel;
(function (ClassLabel) {
    ClassLabel["A"] = "a";
    ClassLabel["A1"] = "a1";
    ClassLabel["A2"] = "a2";
    ClassLabel["B"] = "b";
    ClassLabel["B1"] = "b1";
    ClassLabel["B2"] = "b2";
    ClassLabel["C"] = "c";
    ClassLabel["C1"] = "c1";
    ClassLabel["C2"] = "c2";
    ClassLabel["D"] = "d";
    ClassLabel["D1"] = "d1";
    ClassLabel["D2"] = "d2";
    ClassLabel["E"] = "e";
    ClassLabel["E1"] = "e1";
    ClassLabel["E2"] = "e2";
    ClassLabel["F"] = "f";
    ClassLabel["F1"] = "f1";
    ClassLabel["F2"] = "f2";
})(ClassLabel = exports.ClassLabel || (exports.ClassLabel = {}));
exports.ALL_FUNDING_REQUEST_SCOPES = [
    /** Start a new funding request pipeline run. */
    'fundingRequestPipeline:initiate',
    /**
     * View progress of an existing funding request pipeline run.
     *
     * Implies:
     * - list all historical pipeline runs
     * - view errors encountered during the run
     * - view the inputs used to initiate the run
     */
    'fundingRequestPipeline.progress:view',
    /** View the results of a funding request pipeline run. */
    'fundingRequestPipeline.outputs:view',
];
exports.ALL_CALC_VERIFICATION_SCOPES = [
    /** Start a new calc verification run. */
    'calcVerification:initiate',
    /**
     * View progress of an existing calc verification run.
     *
     * Implies:
     * - list all historical pipeline runs
     * - view errors encountered during the run
     * - view the inputs used to initiate the run
     */
    'calcVerification.progress:view',
    /** View the results of a calc verification run. */
    'calcVerification.outputs:view',
    /** Initiate a verification remediation request on an existing verification report */
    'calcVerification.remediation:initiate',
    /** Upload receivable documentation */
    'calcVerification:uploadReceivableDocumentation',
    /** View receivable documentation */
    'calcVerification.receivableDocumentation:view',
];
exports.ALL_BANK_ACCOUNT_SCOPES = [
    /** View bank account data. */
    'bankAccount:view',
];
/**
 * The borrowing base pipeline scopes below are very broad and is in practice not very secure in their current implementation
 * Longer term, we will want to have workflow-based authz on the bbpl, where we are authorizing based on the intended action on the artifactDocument, artifact, or artifactInstance based on the context of its caller's intention.
 */
exports.ALL_BORROWING_BASE_PIPELINE_SCOPES = [
    /** View bbpl artifact document. */
    'borrowingBasePipeline.artifactDocument:view',
    /** View bbpl artifact. */
    'borrowingBasePipeline.artifact:view',
    /** View bbpl artifact instance. */
    'borrowingBasePipeline.artifactInstance:view',
    /** View bbpl artifact instance in BBPL Monitor. */
    'borrowingBasePipeline.artifactInstance:bbplMonitor:view',
];
/**
 * The borrowing base pipeline scopes below are very broad and is in practice not very secure in their current implementation
 * Longer term, we will want to have workflow-based authz on the bbpl, where we are authorizing based on the intended action on the artifactDocument, artifact, or artifactInstance based on the context of its caller's intention.
 */
exports.ALL_BORROWING_BASE_SCOPES = [
    /** View receivable borrowing base test waivers. */
    'borrowingBase.receivableBorrowingBaseTestWaivers:view',
    /** Update receivable borrowing base test waivers. */
    'borrowingBase.receivableBorrowingBaseTestWaivers:update',
];
// These coarse-grained permissions were introduced to facilitate migration away from legacy auth
// checks that only cared about party type. Going forward we should try to use finer-grained access
// controls.
exports.ALL_LEGACY_AUTH_SCOPES = [
    'legacyScope:isBorrower',
    'legacyScope:isCapitalProvider',
    'legacyScope:isBorrowerOrCapitalProvider',
    'legacyScope:isAdmin',
];
exports.ALL_DATALAKE_AUTH_SCOPES = DataLake_1.ALL_TABLE_PREFIXES.map((tablePrefix) => `datalake.${tablePrefix}`);
//# sourceMappingURL=CreditFacility.js.map